import { useState } from "react";
import { Chart, registerables } from "chart.js";
import "chartjs-adapter-moment";
// Components
import {
  GraphicContainer,
  GraphicRotateDiv,
  HeaderDiv,
  MaximizeGraphicButton,
  MaximizeGraphicImg,
  GraphicTitle,
  ReactTooltipStyled,
  InfoButton,
  InfoImg,
  BetaTitle,
  AxisAndGraphicDiv,
  AxisYSizeDiv,
  AxisY,
  GraphicSizeDiv,
  AxisX,
} from "./styles";
// Assets
import IcoInfoImg from "../../../../assets/icons/ico_info.svg";
import MaximizeImg from "../../../../assets/icons/ico_maximize_graphic.svg";
import MinimizeImg from "../../../../assets/icons/ico_minimize_graphic.svg";

const Graphic = ({
  Title,
  Type,
  data,
  options,
  axisY,
  axisX,
  max = false,
  graphicDescription = "",
  isBeta = false,
  height = "200px",
  paramScales = false,
  plugin = false,
}) => {
  Chart.register(...registerables);
  const [maximizeActive, setMaximizeActive] = useState(false);
  const handleSetMaximizeActive = () => setMaximizeActive(!maximizeActive);

  const renderScales = () => {
    const defaultScales = {
      y: {
        beginAtZero: true,
      },
      x: {
        beginAtZero: true,
      },
    };
    let scales = paramScales ? paramScales : defaultScales;
    if (max) scales.y.max = max;
    return scales;
  };

  const initialPlugin = {
    id: "highlightDrops",
    beforeDraw: (chart) => {
      const { ctx, chartArea, data } = chart;
      const metaSets = chart._metasets;
      const numPoints = data.labels.length;

      ctx.save();

      for (let i = 1; i < numPoints; i++) {
        let shouldHighlight = false;

        for (let datasetIndex = 0; datasetIndex < data.datasets.length; datasetIndex++) {
          const values = data.datasets[datasetIndex].data;
          if (values[i] < values[i - 1]) {
            shouldHighlight = true;
            break;
          }
        }

        if (shouldHighlight) {
          const xStart = metaSets[0].data[i - 1].x;
          const xEnd = metaSets[0].data[i].x;

          ctx.fillStyle = "rgba(241, 90, 36, 0.1)";
          ctx.fillRect(xStart, chartArea.top, xEnd - xStart, chartArea.bottom - chartArea.top);
        }
      }

      ctx.restore();
    },
  };

  const renderChart = () => {
    return (
      <Type
        data={data}
        options={{
          ...options,
          scales: renderScales(),
        }}
        plugins={[plugin ? plugin : initialPlugin]}
      />
    );
  };

  return (
    <GraphicContainer maximizeGraphic={maximizeActive}>
      <GraphicRotateDiv maximizeGraphic={maximizeActive}>
        <HeaderDiv>
          <GraphicTitle>{Title}</GraphicTitle>
          {graphicDescription && (
            <>
              <InfoButton data-for="graphicInfoButton" data-tip={graphicDescription}>
                <InfoImg src={IcoInfoImg} alt="ico-info" />
              </InfoButton>
              <ReactTooltipStyled id="graphicInfoButton" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />
              {isBeta && <BetaTitle>Beta</BetaTitle>}
            </>
          )}
        </HeaderDiv>
        <MaximizeGraphicButton onClick={handleSetMaximizeActive}>
          <MaximizeGraphicImg src={maximizeActive ? MinimizeImg : MaximizeImg} alt="btn-max-min-graphic" maximizeGraphic={maximizeActive} />
        </MaximizeGraphicButton>
        <AxisAndGraphicDiv height={height}>
          <AxisYSizeDiv>
            <AxisY>{axisY}</AxisY>
          </AxisYSizeDiv>
          <GraphicSizeDiv>{renderChart()}</GraphicSizeDiv>
        </AxisAndGraphicDiv>
        <AxisX>{axisX}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
};

export default Graphic;
